export const searchModalOption = {
  id: "search-modal",
  label: "Search all Topicflow",
};
